<template>
    <div class="col-md-6 drop-lg">

        <div v-if="! this.clientHasActivePaypalBA">
            <template v-if="userHasPermission">
                <a href="#" @click.prevent v-b-modal.modal-add-paypal-ba class="payment-group sau-bx-payment payment-desat-img d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400">
                    <span class="mt-2"></span>
                    <img src="/img/logo-paypal.gif" alt="PayPal" class="img-fluid pb-2">
                    <p class="sau-font sm">Link your PayPal account</p>
                </a>
            </template>
            <template v-else>
                <a href="#" @click.prevent class="no-card-hover payment-group sau-bx-payment payment-desat-img d-flex-column h-100 justify-content-center pb-12 border-grey-400 cursor-not-allowed">
                    <span class="mt-2"></span>
                    <img src="/img/logo-paypal.gif" alt="PayPal" class="img-fluid pb-2">
                    <p class="sau-font sm">Contact the account holder to link a PayPal account.</p>
                </a>
            </template>
        </div>

        <!-- Client has paypal and is account view -->
        <div v-if="this.clientHasActivePaypalBA && canUpdatePaymentOptions">
            <div class="payment-group sau-bx-payment active d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400 cursor-default">
                <div>
                    <span class="mt-2"></span>
                    <img src="/img/logo-paypal.gif" alt="PayPal" class="img-fluid pb-2">
                    <p class="sau-font sm">{{this.clientActivePaypalBAEmail}}</p>
                </div>
                <div class="payment-method-options">
                    <div class="sau-menu">
                        <button class="dropbtn text-green">
                            Options
                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                        </button>
                        <div class="sau-menu-content dd py-4 px-6">
                            <button class="block" v-b-modal.modal-add-paypal-ba>Link New Account</button>
                            <button class="block" v-b-modal.modal-remove-paypal-ba>Unlink Account</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Client has paypal and is payment view -->
        <div v-if="this.clientHasActivePaypalBA && ! canUpdatePaymentOptions" @click.prevent="setPaymentMethod('paypal')">
            <div class="payment-group sau-select lg center payment d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400" :class="{ selected: this.paymentMethodSelected === 'paypal' }">
                <label for="paypal">
                    <input id="paypal" type="radio" name="payment-type" value="paypal" v-model="this.paymentMethodSelected">
                    <span class="mt-2"></span>
                    <img src="/img/logo-paypal.gif" alt="PayPal" class="img-fluid pb-2 payment-max">
                    <p class="sau-font sm">{{ this.clientActivePaypalBAEmail }}</p>
                </label>
            </div>
        </div>

        <!-- Modal Add Paypal BA -->
        <sau-add-paypal-ba v-on:cancel="reset()"></sau-add-paypal-ba>
        <!-- Modal Remove Paypal BA -->
        <sau-remove-paypal-ba v-on:cancel="reset()"></sau-remove-paypal-ba>

    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import AddPayPalBA from "./_PaymentPPBAAdd";
    import RemovePayPalBA from "./_PaymentPPBARemove";

    export default {

        components: {
            'sau-add-paypal-ba': AddPayPalBA,
            'sau-remove-paypal-ba': RemovePayPalBA
        },

        methods: {
            reset() {
                this.$store.commit("setCreditCardImage", this.getCreditCardImage());
            },
        },

        computed: {
            userHasPermission() {
                return this.userDetails.whmcs_contact_id
                    ? this.userDetails.permissions.split(",").indexOf('profile') > -1
                    : true;
            },
            ...mapGetters(['canUpdatePaymentOptions']),
        }
    }
</script>

<style scoped>

</style>
